// Display-only status helpers — derive the user-facing label/colour
// from a raw repair-request record without changing what's stored in
// MongoDB. We still persist `status='Cancelled'` + a free-form
// `cancellation_reason` so all existing analytics, status workflows
// and emails keep working; only the *label* changes.

const NO_SHOW_REASON_TOKENS = ['no show', 'no-show', 'noshow'];

const isNoShowReason = (reason) => {
  if (!reason || typeof reason !== 'string') return false;
  const lower = reason.toLowerCase();
  return NO_SHOW_REASON_TOKENS.some((t) => lower.includes(t));
};

/**
 * Return the user-facing status label for a repair request.
 *
 * Examples:
 *   { status: 'Cancelled', cancellation_reason: 'Customer No-Show' } → 'No Show'
 *   { status: 'Cancelled', cancellation_reason: 'Customer Request' } → 'Cancelled'
 *   { status: 'Completed' }                                          → 'Completed'
 */
export function getDisplayStatus(req) {
  if (!req) return '';
  if (req.status === 'Cancelled' && isNoShowReason(req.cancellation_reason)) {
    return 'No Show';
  }
  return req.status || '';
}

// Convenience flag — true when the request was cancelled specifically
// because the customer didn't turn up.
export function isNoShow(req) {
  return req?.status === 'Cancelled' && isNoShowReason(req?.cancellation_reason);
}
